import { Helmet } from "react-helmet";
import SolutionItemHero from "../../components/reusables/hero/SolutionItemHero";
import Authority from "../../components/reusables/Authority";
import HowWeWork from "../../components/solutions/HowWeWork";
import SolutionCTA from "../../components/solutions/SolutionCTA";
import Branding from "../../components/solutions/branding/Branding";
import BrandingFaqsBody from "../../components/faqs/BrandingFaqsBody";
import RelatedBranding from "../../components/solutions/branding/RelatedBranding";

export default function GraphicBranding() {
  return (
    <>
      <Helmet>
        <link
          rel="canonical"
          href="https://www.ntuna.com/solutions/branding-graphic-design"
        />
        <meta
          name="description"
          content="Get your digital branding and graphic design done right by NTUNA.COM. From logo design, banners, flyers to overall brand identity."
        />
        
        <meta
          property="og:description"
          content="Get your digital branding and graphic design done right by NTUNA.COM. From logo design, banners, flyers to overall brand identity."
        />
        <meta
          property="og:title"
          content="NTUNA.COM | Solutions | Branding & Graphic Design"
        />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627082/ntuna_solutions_banner_1200x628_c8xerm.jpg"
        />

        <meta
          name="twitter:title"
          content="NTUNA.COM | Solutions | Branding & Graphic Design"
        />
        <meta
          name="twitter:text:title"
          content="NTUNA.COM | Solutions | Branding & Graphic Design"
        />
        <meta
          name="twitter:description"
          content="Get your digital branding and graphic design done right by NTUNA.COM. From logo design, banners, flyers to overall brand identity."
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627082/ntuna_solutions_banner_1200x628_c8xerm.jpg"
        />
        <title>NTUNA.COM | Solutions | Branding & Graphic Design</title>
      </Helmet>
      <SolutionItemHero
        title="Branding & Graphic Design"
        subtitle="Get your branding and graphic design done right. From logo design, social media content design, banners, flyers to corporate designs and overall brand identity."
        casestudylink="/#"
        CTAtext="Get Free Quote"
        mainCTAlink="https://form.jotform.com/ntuna/get-free-quote"
      />
      <Authority />
      <Branding />
      <SolutionCTA ctaTitle="Ready To Have Your Branding Done Right?" />
      <BrandingFaqsBody />
      <SolutionCTA ctaTitle="Ready To Have Your Branding Done Right?" />
      <HowWeWork />
      <SolutionCTA ctaTitle="Ready To Have Your Branding Done Right?" />
      <RelatedBranding />
    </>
  );
}
